import { useEffect, useState } from 'react';

export const COLLAPSED_FILTER_LIMIT = 10;

export default function useExpandedFilterOptions(
  hasAdditionalSelection: boolean,
  initiallyExpanded = false
) {
  const [expanded, setExpanded] = useState(initiallyExpanded);

  useEffect(() => {
    if (hasAdditionalSelection) setExpanded(true);
  }, [hasAdditionalSelection]);

  return { expanded, toggleExpanded: () => setExpanded((previous) => !previous) };
}
